(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Treatments drop — Escape to dismiss (WCAG 2.1 §1.4.13, Dismissible).

     The panel opens on :hover / :focus-within with no JS, which is what keeps it
     working when scripts fail. But it is 720px, absolutely positioned, and DOES
     obscure content, so the "does not obscure" exception to 1.4.13 does not
     apply and it needs a dismiss mechanism. Dawn wires onKeyUpEscape to every
     other header dropdown (global.js), so without this, Escape closes every menu
     in this nav bar EXCEPT Treatments — a user who learns the behaviour on one
     item finds it silently broken on another.

     PROGRESSIVE ENHANCEMENT IS PRESERVED: with no JS nothing sets the attribute
     and the panel behaves exactly as it does today. This only ever ADDS the
     ability to close.

     The attribute is cleared on mouseleave and on focus leaving the item, so the
     dismissal lasts for one visit rather than latching. Focus moves back to the
     trigger link, otherwise focus would still be inside a panel that is now
     visibility:hidden and the browser would drop it to the top of the document.

     `keydown`, not `keyup`: keyup would leave the key's default action to run
     first, and Escape during an IME composition or a native autofill popup is
     handled by the browser before it reaches here either way. */
  (function tclNavDropDismiss() {
    const DISMISSED = 'data-tl-navdrop-dismissed';

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      /* THE HOVER BRANCH IS THE POINT. 1.4.13 is about content triggered by
         HOVER, and a pointer-only user has focus on <body> — `closest` returns
         null and an earlier version of this handler did nothing at all for
         exactly the user it was written for. Keyboard users at least had Tab.
         `:hover` is how the panel is open for them, so it is how we find it. */
      const focused = event.target.closest?.('.tl-has-drop');
      const item = focused || document.querySelector('.tl-has-drop:hover');
      if (!item || !item.querySelector('.tl-navdrop')) return;
      item.setAttribute(DISMISSED, '');
      /* Only move focus if focus was IN the panel — otherwise it would be
         stranded in a visibility:hidden subtree. Yanking a mouse user's focus
         to the nav on Escape would be its own defect. */
      if (focused) item.querySelector('a')?.focus();
    });

    const release = (event) => {
      const item = event.target.closest?.('.tl-has-drop');
      if (!item) return;
      // focusout fires before focus lands, so defer and re-check where focus went.
      requestAnimationFrame(() => {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) {
          item.removeAttribute(DISMISSED);
        }
      });
    };
    document.addEventListener('focusout', release);
    document.addEventListener('mouseleave', release, true);
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* CONDENSED NAV — dark-green bar once the top bar has scrolled away.
     Paints via `tcl-nav-condensed` on `.section-header`; all the colour is in
     tcl-header.css §13.

     WHY THIS IS NOT HUNG ON DAWN'S `scrolled-past-header`, which is right there
     on the same element and looks like a free ride:

     1. IT FIRES TOO LATE. `StickyHeader` gates on `headerBounds.bottom`, the
        bottom of `.section-header` — so announcement + header, ~108px here. The
        top bar is gone at ~40px. That is a visible ~68px of scrolling where the
        bar the user is watching has already left and the colour has not changed.
     2. `headerBounds` IS CAPTURED ONCE, by an IntersectionObserver that
        `observer.disconnect()`s in its first callback, and it is an
        `intersectionRect` — i.e. VIEWPORT-CLIPPED. Load the page already scrolled
        (a refresh mid-page, or a `#anchor`) and the rect is short by however much
        was above the fold, so the threshold is wrong for the rest of the session.

     UNTIL 2026-10-14 this observed the announcement bar (`.utility-bar`)
     leaving the viewport. The bar is now out of flow and only shown WHILE
     condensed (see below and tcl-header.css §14), so there is nothing in the
     page to observe: condense past a short scroll instead. 8px is far enough
     not to flicker on an elastic/rubber-band scroll at the top.

     Runs at most once per frame. The enclosing section-javascript block is a
     section ASSET — one copy per section TYPE, not per instance — so there is no
     double-bind here.

     NOTE FOR EDITORS: do not write the section-javascript tag's Liquid
     delimiters in this comment. Theme check raises
     StaticStylesheetAndJavascriptTags on a Liquid tag inside a JS block, and it
     cannot tell prose from code — the delimiters alone are enough to fail it. */
  (function condensedNav() {
    const CLASS = 'tcl-nav-condensed';
    const section = document.querySelector('.section-header');
    if (!section) return;

    /* THE TOP BAR RIDES THE SAME STATE (owner, 2026-10-14). The announcement
       bar is out of flow and hidden at the top (tcl-header.css §14); condensed,
       it slides in above the header. So the trigger can no longer be "the bar
       has scrolled away" — the bar is never in the page to scroll — and it is
       the short-scroll threshold below for every page, bar or no bar. */
    const bar = document.querySelector('.announcement-bar-section');
    const root = document.documentElement;

    const publish = (condensed) => {
      const barH = bar ? bar.offsetHeight : 0;
      root.style.setProperty('--tl-topbar-h', `${barH}px`);
      // ALWAYS header + bar, condensed or not. Dawn's StickyHeader writes the
      // header alone (on load and at 990px); this lands after it. It must NOT
      // follow the condensed state: the bar only appears past 8px of scroll, and
      // a `--header-height` that grows mid-scroll leaves every consumer that
      // resolved it earlier 39px short — an anchor's scroll-margin, the
      // price-list heading's 220ms `top` transition, the autohide's flow read.
      // At scroll 0 nothing is pinned yet, so the extra 39px is never seen.
      root.style.setProperty('--header-height', `${section.offsetHeight + barH}px`);
    };

    let current = null;
    const setState = (condensed) => {
      if (condensed !== current) {
        current = condensed;
        section.classList.toggle(CLASS, condensed);
        if (bar) document.body.classList.toggle('tcl-topbar-on', condensed);
      }
      // EVERY frame, not only on a state change: Dawn's StickyHeader rewrites
      // `--header-height` (header alone) from its own 990px media listener, and
      // the order of two media-query listeners is not ours to choose. A probe
      // resizing 1440 -> 390 mid-scroll caught the pinned price-list headings
      // 39px (the bar) above the filter bar until the next state change.
      publish(condensed);
    };

    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        setState((window.pageYOffset || document.documentElement.scrollTop) > 8);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    // a frame later, so this lands AFTER Dawn's own listener for the same change
    const republish = () => requestAnimationFrame(() => publish(!!current));
    window.matchMedia('(max-width: 990px)').addEventListener('change', republish);
    window.addEventListener('resize', republish, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hubspot-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const targets = document.querySelectorAll('.lp-hubspot-form__target[data-hs-form]');
    if (!targets.length) return;

    let loader = null;
    const loadScript = () => {
      loader ||= new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return loader;
    };

    const init = (el) => {
      if (el.dataset.hsDone) return;
      el.dataset.hsDone = '1';
      loadScript()
        .then(() => {
          window.hbspt.forms.create({
            region: el.dataset.hsRegion || 'na1',
            portalId: el.dataset.hsPortal,
            formId: el.dataset.hsForm,
            target: `[id="${el.id}"]`,
            onFormReady: () => el.classList.add('is-loaded'),
            // THE CONVERSION — the landing-page twin of the sticky-book modal's
            // handler. A Shopify pixel sees Shopify events only, so a booking is
            // invisible to GA4 and Meta without this. The custom pixel subscribes
            // to `tcl_booking_submitted`; see analytics/README.md.
            //
            // TRACKING MUST NEVER BREAK A BOOKING: by the time this fires the
            // lead is already with HubSpot, so the body is fully guarded and
            // wrapped. A reporting gap beats an exception on the revenue path.
            onFormSubmitted: () => {
              try {
                const sa = window.Shopify && window.Shopify.analytics;
                if (!sa || typeof sa.publish !== 'function') return;
                sa.publish('tcl_booking_submitted', { treatment: '', source: 'lp-form' });
              } catch (err) {
                // Swallowed on purpose — see above.
              }
            },
          });
        })
        .catch(() => {
          delete el.dataset.hsDone;
        });
    };

    if (!('IntersectionObserver' in window)) {
      targets.forEach(init);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          init(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );
    targets.forEach((el) => io.observe(el));

    // A click on any in-page anchor pointing at the form's section loads it
    // immediately, so the form is ready by the time the scroll lands.
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;
      const hash = link.hash && link.hash.slice(1);
      if (!hash) return;
      const section = document.getElementById(hash);
      if (!section) return;
      section.querySelectorAll('.lp-hubspot-form__target[data-hs-form]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcl-finder"] && !Shopify.designMode) return;
  try {
    
  /*
    Concern finder — ARIA tabs, plus the cross-section contract that lets the
    hero's concern chips open a tab.

    Everything is delegated from `document`, so there is no per-section init to
    re-run and Theme Editor section reloads need no `shopify:section:load`
    handler. The one piece of per-section state — the `is-enhanced` class — is
    applied on load and again whenever a section is re-rendered.

    Chip contract: any element anywhere on the page carrying
    `data-tcl-concern="<key>"` activates the tab whose `data-tl-finder-tab`
    equals that key. The key is the concern label passed through `handleize`.
    The hero emits those chips as ordinary anchors to `#tl-finder`, so the
    scroll is the browser's and still works with this script absent.
  */
  (function () {
    var TABS = '[data-tl-finder]';

    function enhance() {
      document.querySelectorAll(TABS).forEach(function (root) {
        root.classList.add('is-enhanced');
      });
    }

    function tabsIn(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-tl-finder-tab]'));
    }

    function activate(root, key, focus) {
      tabsIn(root).forEach(function (tab) {
        var on = tab.getAttribute('data-tl-finder-tab') === key;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      root.querySelectorAll('[data-tl-finder-pane]').forEach(function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-tl-finder-pane') === key);
      });
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-tl-finder-tab]');
      if (tab) {
        var root = tab.closest(TABS);
        if (root) activate(root, tab.getAttribute('data-tl-finder-tab'), false);
        return;
      }

      var chip = event.target.closest('[data-tcl-concern]');
      if (!chip) return;
      var key = chip.getAttribute('data-tcl-concern');
      document.querySelectorAll(TABS).forEach(function (root) {
        // Only react in a finder that actually has this concern, so a chip
        // naming a concern nobody offers scrolls without silently blanking
        // the panes.
        if (root.querySelector('[data-tl-finder-tab="' + key + '"]')) activate(root, key, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('[data-tl-finder-tab]');
      if (!tab) return;
      var root = tab.closest(TABS);
      if (!root) return;

      var tabs = tabsIn(root);
      var i = tabs.indexOf(tab);
      var to = null;
      if (event.key === 'ArrowRight') to = (i + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') to = (i - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') to = 0;
      else if (event.key === 'End') to = tabs.length - 1;
      if (to === null) return;

      event.preventDefault();
      activate(root, tabs[to].getAttribute('data-tl-finder-tab'), true);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhance);
    } else {
      enhance();
    }
    document.addEventListener('shopify:section:load', enhance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcl-price-list"] && !Shopify.designMode) return;
  try {
    
  /*
    Price list — client-side facet/chip/search filtering over server-rendered rows.

    DELEGATED FROM `document` like tcl-treatment-browser and tcl-finder, so there
    is no per-section init to re-run, a Theme Editor section reload needs no
    `shopify:section:load` wiring beyond re-applying the enhancement class, and
    two instances on one page work with every lookup scoped to the nearest root.

    THE MODEL (see the Liquid comment at the top of this file for why):
      visible = facetOn(row) AND (noChips OR chipOn(row)) AND searchMatches(row)
    Turning a facet off hides its chips AND clears them, so a lit chip can never
    belong to a dead facet — the contradictory empty state is unreachable.
  */
  (function () {
    var ROOT = '[data-tpl-root]';

    function roots() {
      return Array.prototype.slice.call(document.querySelectorAll(ROOT));
    }

    /* Categories are read off the rendered DOM rather than from a second list in
       the schema — one source, so chips cannot drift from the rows they filter. */
    function categories(root) {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-tpl-cat]'),
        function (el) {
          return {
            key: el.getAttribute('data-tpl-cat'),
            facet: el.getAttribute('data-facet'),
            label: (el.querySelector('.tl-plist__cat-title') || {}).textContent || el.getAttribute('data-tpl-cat')
          };
        }
      );
    }

    function activeFacets(root) {
      var on = [];
      root.querySelectorAll('[data-tpl-facet]').forEach(function (i) {
        if (i.checked) on.push(i.value);
      });
      return on;
    }

    function selectedChips(root) {
      var on = [];
      root.querySelectorAll('[data-tpl-chip]').forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true' && !b.hidden) on.push(b.getAttribute('data-tpl-chip'));
      });
      return on;
    }

    function buildChips(root) {
      var wrap = root.querySelector('[data-tpl-chips]');
      if (!wrap || wrap.children.length) return;
      categories(root).forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tl-plist__chip';
        b.setAttribute('data-tpl-chip', c.key);
        b.setAttribute('data-facet', c.facet);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = c.label.trim();
        wrap.appendChild(b);
      });
    }

    function norm(s) {
      return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function apply(root) {
      var facets = activeFacets(root);

      /* A chip whose facet just went off is hidden AND deselected, in that
         order, before anything reads the selection back. */
      root.querySelectorAll('[data-tpl-chip]').forEach(function (b) {
        var live = facets.indexOf(b.getAttribute('data-facet')) !== -1;
        b.hidden = !live;
        if (!live) b.setAttribute('aria-pressed', 'false');
      });

      var chips = selectedChips(root);
      var qEl = root.querySelector('[data-tpl-q]');
      var q = qEl ? norm(qEl.value) : '';
      var terms = q ? q.split(' ') : [];

      var shown = 0;
      var total = 0;

      root.querySelectorAll('[data-tpl-row]').forEach(function (row) {
        /* A tier parent ("MILBON Hair Treatment") is a LABEL for the four length
           rows under it and carries no price of its own, so it is never counted
           — not in the total and not in the shown. It is still filtered like any
           other row here; the pass below then overrides its visibility to follow
           its tiers. Counting it and subtracting later is what produced
           "Showing 1 of 93" when two tiers were visible: the subtraction fired
           for a parent the filter had already excluded from `shown`. */
        var isParent = row.hasAttribute('data-tpl-parent');
        if (!isParent) total++;
        var on = facets.indexOf(row.getAttribute('data-facet')) !== -1;
        if (on && chips.length) on = chips.indexOf(row.getAttribute('data-cat')) !== -1;
        if (on && terms.length) {
          var hay = row.getAttribute('data-search') || '';
          /* Every term must appear — "milbon long" should not match every row
             containing "long". The tier rows carry their parent's name in
             data-search, which is what lets that query hit at all. */
          for (var i = 0; i < terms.length; i++) {
            if (hay.indexOf(terms[i]) === -1) { on = false; break; }
          }
        }
        row.hidden = !on;
        if (on && !isParent) shown++;
      });

      /* A tier parent means nothing without its tiers and everything with them,
         so its visibility FOLLOWS them rather than its own match: searching
         "milbon" shows the label above all four lengths, and searching "long"
         shows it above the two that match. Derived from the tiers themselves so
         it cannot disagree with what was just hidden. It is not in `shown` —
         see the note in the row loop. */
      root.querySelectorAll('[data-tpl-parent]').forEach(function (p) {
        var key = p.getAttribute('data-tpl-parent');
        var tiers = root.querySelectorAll('[data-tier-of="' + key + '"]');
        p.hidden = !Array.prototype.some.call(tiers, function (t) { return !t.hidden; });
      });

      /* A group heading over nothing, and a category heading over nothing, are
         the same defect the Liquid gates against server-side. Each <tbody> holds
         one group, so hiding it takes the heading and the rows together. */
      root.querySelectorAll('[data-tpl-grp]').forEach(function (g) {
        g.hidden = !Array.prototype.some.call(
          g.querySelectorAll('[data-tpl-row]'),
          function (r) { return !r.hidden; }
        );
      });
      root.querySelectorAll('[data-tpl-cat]').forEach(function (c) {
        c.hidden = !Array.prototype.some.call(
          c.querySelectorAll('[data-tpl-row]'),
          function (r) { return !r.hidden; }
        );
      });

      var none = root.querySelector('[data-tpl-none]');
      if (none) none.hidden = shown !== 0;

      /* "Filtering" means the visitor changed something — NOT "fewer than every
         facet is on". The page now OPENS with salon services and add-ons off,
         and the old test read that opening state as a filtered one: "Showing 43
         of 95" and a lit Reset button before anyone had touched a control.

         The baseline is `defaultChecked`, which reflects the `checked` ATTRIBUTE
         the generated snippet ships — so it tracks price-list.json's `default`
         flags with nothing to keep in sync here. */
      var defaults = [];
      root.querySelectorAll('[data-tpl-facet]').forEach(function (i) {
        if (i.defaultChecked) defaults.push(i.value);
      });
      var atDefault =
        facets.length === defaults.length &&
        facets.every(function (v) { return defaults.indexOf(v) !== -1; });
      var filtering = chips.length > 0 || terms.length > 0 || !atDefault;

      var reset = root.querySelector('[data-tpl-reset]');
      if (reset) reset.hidden = !filtering;

      var qclear = root.querySelector('[data-tpl-qclear]');
      if (qclear) qclear.hidden = !(qEl && qEl.value);
    }

    function reset(root) {
      /* Back to the OPENING state, not to everything-on: Reset must land on the
         same view a first-time visitor gets, or "reset" shows more than the
         page ever showed by itself. */
      root.querySelectorAll('[data-tpl-facet]').forEach(function (i) { i.checked = i.defaultChecked; });
      root.querySelectorAll('[data-tpl-chip]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var q = root.querySelector('[data-tpl-q]');
      if (q) q.value = '';
      apply(root);
    }

    /* PUBLISH THE ANCHOR OFFSET so a #category jump clears the sticky bar.
       `--tl-anchor-offset` is the theme's existing site-wide variable, read by
       `[data-tcl-anchor]` in tcl-base.css and published the same way by
       tcl-page-nav.js — feeding it is what keeps this page from needing a
       competing scroll-margin rule (see the CSS note).

       MEASURED, never a constant: the bar wraps to a different number of rows at
       every breakpoint, and Dawn's --header-height itself changes with the
       announcement bar and on scroll. The bar's own bottom edge already includes
       the header, since the bar is parked directly beneath it — so this reads
       one rect rather than adding two numbers that can disagree. */
    function publishAnchorOffset(root) {
      var bar = root.querySelector('[data-tpl-bar]');
      if (!bar) return;
      /* Feeds the CSS above its measured value. The CSS already works from its
         static fallback before this runs, so this only ever REFINES the offset —
         it is not what makes deep links land. */
      var write = function () {
        document.documentElement.style.setProperty(
          '--tl-plist-bar',
          bar.getBoundingClientRect().height + 'px'
        );
      };
      write();
      /* The guard covers the resize listener too, not just the observer:
         `enhance()` re-runs on every `shopify:section:load`, so an unguarded
         `addEventListener` stacks a new copy on each Theme Editor reload. */
      if (!bar.dataset.tplObserved) {
        bar.dataset.tplObserved = '1';
        if (window.ResizeObserver) new ResizeObserver(write).observe(bar);
        window.addEventListener('resize', write);
      }
    }

    function enhance() {
      roots().forEach(function (root) {
        buildChips(root);
        root.classList.add('is-enhanced');
        apply(root);
        publishAnchorOffset(root);
      });
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-tpl-chip]') : null;
      if (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        apply(chip.closest(ROOT));
        return;
      }
      var r = e.target.closest ? e.target.closest('[data-tpl-reset]') : null;
      if (r) { reset(r.closest(ROOT)); return; }
      var qc = e.target.closest ? e.target.closest('[data-tpl-qclear]') : null;
      if (qc) {
        var root = qc.closest(ROOT);
        var q = root.querySelector('[data-tpl-q]');
        if (q) { q.value = ''; q.focus(); }
        apply(root);
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-tpl-facet]')) apply(e.target.closest(ROOT));
    });

    document.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches('[data-tpl-q]')) apply(e.target.closest(ROOT));
    });

    /* The form exists for the search landmark and for Enter-to-search semantics;
       it must never navigate. */
    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('[data-tpl-form]')) e.preventDefault();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhance);
    } else {
      enhance();
    }
    document.addEventListener('shopify:section:load', enhance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcl-treatment-browser"] && !Shopify.designMode) return;
  try {
    
  /*
    Treatment browser — client-side facet filtering over server-rendered cards.

    DELEGATED FROM `document`, like tcl-finder's tab script, so there is no
    per-section init to re-run and a Theme Editor section reload needs no
    `shopify:section:load` wiring beyond re-applying the enhancement class. It
    also means two instances of this section on one page work with no extra
    code — every lookup is scoped to the nearest `.tl-tbrowse` root.

    SEMANTICS: OR within a facet, AND across facets. Ticking "Hair Loss" and
    "Dandruff" widens; ticking "Hair Loss" and then "Scalp" narrows. That is what
    every faceted catalogue does, and getting it backwards is the classic bug —
    a card must match EVERY group that has a selection, and ANY value within it.

    An untouched group is not a constraint at all, which is why the empty-set
    check is `size === 0` rather than a count of matches.
  */
  (function () {
    var ROOT = '.tl-tbrowse';

    function enhance() {
      document.querySelectorAll(ROOT).forEach(function (root) {
        root.classList.add('is-enhanced');
      });
    }

    /* Selected values per facet name, e.g. {concern: Set, band: Set}. Only groups
       with at least one checked box appear, so an untouched facet imposes nothing. */
    function selections(root) {
      var out = {};
      root.querySelectorAll('[data-tlb-filter]').forEach(function (input) {
        if (!input.checked) return;
        var name = input.getAttribute('data-tlb-filter');
        (out[name] = out[name] || []).push(input.value);
      });
      return out;
    }

    function matches(item, sel) {
      for (var name in sel) {
        if (!Object.prototype.hasOwnProperty.call(sel, name)) continue;
        if (sel[name].indexOf(item.getAttribute('data-' + name)) === -1) return false;
      }
      return true;
    }

    function apply(root) {
      var sel = selections(root);
      var active = 0;
      for (var k in sel) {
        if (Object.prototype.hasOwnProperty.call(sel, k)) active += sel[k].length;
      }

      var shown = 0;
      var total = 0;
      root.querySelectorAll('[data-tlb-item]').forEach(function (item) {
        total++;
        var on = matches(item, sel);
        if (on) shown++;
        item.hidden = !on;
      });

      /* A concern group whose every card is filtered out must lose its HEADING
         too, or the page shows a concern name over nothing — the same defect the
         Liquid gates against server-side. Counted from the items themselves so it
         cannot disagree with what was just hidden. */
      root.querySelectorAll('[data-tlb-group]').forEach(function (group) {
        var any = Array.prototype.some.call(
          group.querySelectorAll('[data-tlb-item]'),
          function (i) { return !i.hidden; }
        );
        group.hidden = !any;
      });

      var none = root.querySelector('[data-tlb-none]');
      if (none) none.hidden = shown !== 0;

      var count = root.querySelector('[data-tlb-count]');
      if (count) {
        if (active === 0) {
          count.textContent = count.getAttribute('data-all') || count.textContent;
        } else {
          /* Both strings come from the schema — see the note beside the markup.
             Square-bracket tokens, deliberately: a curly-brace placeholder in a
             merchant-typed setting would be parsed as Liquid output, and writing
             one even inside THIS comment trips theme check's
             StaticStylesheetAndJavascriptTags error, which is how the rule was
             confirmed rather than assumed. */
          var fmt = count.getAttribute('data-fmt') || '[n] of [m]';
          count.textContent = fmt.split('[n]').join(shown).split('[m]').join(total);
        }
      }

      var badge = root.querySelector('[data-tlb-badge]');
      if (badge) {
        badge.textContent = String(active);
        badge.hidden = active === 0;
      }

      var clear = root.querySelector('[data-tlb-clear]');
      if (clear) clear.hidden = active === 0;
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('[data-tlb-filter]');
      if (!input) return;
      var root = input.closest(ROOT);
      if (root) apply(root);
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-tlb-clear]');
      if (!btn) return;
      var root = btn.closest(ROOT);
      if (!root) return;
      root.querySelectorAll('[data-tlb-filter]').forEach(function (i) { i.checked = false; });
      apply(root);
    });

    /* The unfiltered copy is stashed on the node at enhance time so `apply` can
       restore it verbatim when the last box is unticked, rather than rebuilding a
       sentence the merchant may have translated. */
    function stashAll() {
      document.querySelectorAll('[data-tlb-count]').forEach(function (el) {
        if (!el.getAttribute('data-all')) el.setAttribute('data-all', el.textContent.trim());
      });
    }

    function init() {
      stashAll();
      enhance();
      document.querySelectorAll(ROOT).forEach(apply);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcl-treatment-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcl-before-after')) {
    customElements.define(
      'tcl-before-after',
      class extends HTMLElement {
        connectedCallback() {
          this.range = this.querySelector('.tl-ba__range');
          if (!this.range) return;
          this.range.addEventListener('input', () => this.update());
          this.update();
        }
        update() {
          this.style.setProperty('--tl-ba-pos', this.range.value + '%');
        }
      }
    );
  }
  /* Comparison cards (snippets/tcl-compare-cards.liquid): below 750px the
     button row becomes a two-way switch that shows one card at a time. Above
     it, and without this script, every card shows. The ARIA tab roles are only
     applied while the switch is visible, so a desktop reader meets plain
     articles, not tabpanels with no tabs. */
  if (!customElements.get('tl-compare')) {
    customElements.define(
      'tl-compare',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this.list = this.querySelector('[data-cmp-tablist]');
          this.tabs = Array.from(this.querySelectorAll('[data-cmp-tab]'));
          this.cards = Array.from(this.querySelectorAll('[data-cmp-card]'));
          if (!this.list || this.tabs.length < 2 || this.tabs.length !== this.cards.length) return;
          this._ready = true;
          this.idx = 0;
          this.mq = window.matchMedia('(max-width: 749px)');
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, false));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
          this.onChange = () => this.apply();
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.onChange);
          else if (this.mq.addListener) this.mq.addListener(this.onChange);
          this.apply();
        }
        disconnectedCallback() {
          if (!this.mq || !this.onChange) return;
          if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onChange);
          else if (this.mq.removeListener) this.mq.removeListener(this.onChange);
        }
        apply() {
          const on = this.mq.matches;
          this.toggleAttribute('data-switching', on);
          this.list.hidden = !on;
          if (on) this.list.setAttribute('role', 'tablist');
          else this.list.removeAttribute('role');
          this.tabs.forEach((tab, i) => {
            const active = i === this.idx;
            if (on) {
              tab.setAttribute('role', 'tab');
              tab.setAttribute('aria-selected', String(active));
              tab.tabIndex = active ? 0 : -1;
            } else {
              tab.removeAttribute('role');
              tab.removeAttribute('aria-selected');
              tab.removeAttribute('tabindex');
            }
          });
          this.cards.forEach((card, i) => {
            if (on) {
              card.setAttribute('role', 'tabpanel');
              card.setAttribute('aria-labelledby', this.tabs[i].id);
              card.hidden = i !== this.idx;
            } else {
              card.removeAttribute('role');
              card.removeAttribute('aria-labelledby');
              card.hidden = false;
            }
          });
        }
        select(i, focus) {
          this.idx = i;
          this.apply();
          if (focus) this.tabs[i].focus();
        }
        onKey(e, i) {
          const n = this.tabs.length;
          let next = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = n - 1;
          if (next === -1) return;
          e.preventDefault();
          this.select(next, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
